var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.665 12.665C18.665 13.1954 18.4543 13.7041 18.0792 14.0792C17.7041 14.4543 17.1954 14.665 16.665 14.665H4.66501L0.665009 18.665V2.66498C0.665009 2.13455 0.875722 1.62584 1.25079 1.25076C1.62587 0.875692 2.13458 0.664978 2.66501 0.664978H16.665C17.1954 0.664978 17.7041 0.875692 18.0792 1.25076C18.4543 1.62584 18.665 2.13455 18.665 2.66498V12.665Z",
    fill: "#4A81E6",
    stroke: "#4A81E6",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66501 4.66498H13.665",
    stroke: "white",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66501 8.66498H10.665",
    stroke: "white",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatFilled);
export default __webpack_public_path__ + "static/media/chat_filled.416d79ebcd31f02cfe8842a622e661a6.svg";
export { ForwardRef as ReactComponent };